import React, { useState, useEffect, useRef } from 'react';
import './LoadingScreen.css';

const MIN_LOADING_TIME = 1500; // ms - temps minimum d'affichage
const SMOOTH_SPEED = 30; // ms entre chaque incrément

const LoadingScreen = ({ progress, active }) => {
  const [displayProgress, setDisplayProgress] = useState(0);
  const startTimeRef = useRef(Date.now());

  // Progression fluide et visible
  useEffect(() => {
    // Si le progrès réel est supérieur à l'affichage, on anime vers le haut
    if (displayProgress < progress) {
      const timer = setTimeout(() => {
        setDisplayProgress(prev => {
          const diff = progress - prev;
          // Incrément adaptatif : plus lent au début, plus rapide vers la fin
          const increment = Math.max(0.5, Math.min(diff * 0.1, 2));
          return Math.min(prev + increment, progress);
        });
      }, SMOOTH_SPEED);

      return () => clearTimeout(timer);
    }

    // Si on est à 100%, on s'assure d'afficher 100
    if (progress === 100 && displayProgress < 100) {
      const timer = setTimeout(() => {
        setDisplayProgress(100);
      }, SMOOTH_SPEED);
      return () => clearTimeout(timer);
    }
  }, [progress, displayProgress]);

  // Respect du temps minimum avant disparition
  if (!active) {
    const elapsed = Date.now() - startTimeRef.current;
    if (elapsed < MIN_LOADING_TIME) return null;
    return null;
  }

  return (
    <div className="loading-screen">
      <div className="loading-content">
        <div className="loading-bar">
          <div
            className="loading-bar-fill"
            style={{ width: `${displayProgress}%` }}
          />
        </div>
        <div className="loading-percentage">
          {Math.round(displayProgress)}
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen;